"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import AiChatDynamic from "./AiChatDynamic";
import UserChat from "./UserChat";
import { HOME_PATH } from "@/lib/app-routes";

// Плавающие виджеты (AI-чат «про магазин» и чат поддержки) — это функции для
// вошедших пользователей кабинета. На публичных страницах без логина (FrogArt,
// расшаренные виды) их показывать нельзя: они путают и дёргают API без сессии (401).
// /page/ — страницы новой версии: свои виджеты у неё в шапке, а плавающие
// перекрывали бы нижний край документа.
const HIDE_PREFIXES = ["/frogart", "/shared/", "/legal/", "/landing", "/flow-test", "/home", "/page/", "/product-groups", "/notes", "/autopilot-rule-lab"];

export default function FloatingWidgets() {
  const pathname = usePathname();
  const hidden = pathname === HOME_PATH || HIDE_PREFIXES.some((p) => pathname.startsWith(p)) || /^\/(view|page)\/[^/]+\/embed/.test(pathname);
  // В демо-режиме AI-бар не показываем: чат в демо всё равно отключён
  // (мутации 403), а полоса перекрывала плашку «Демо-режим» внизу.
  const [demo, setDemo] = useState(false);
  useEffect(() => {
    if (hidden) return;
    fetch("/api/auth/me")
      .then(r => (r.ok ? r.json() : null))
      .then(d => setDemo(Boolean(d?.user?.demo)))
      .catch(() => {});
  }, [hidden]);
  if (hidden) return null;
  return (
    <>
      {!demo && <AiChatDynamic />}
      <UserChat />
    </>
  );
}
